import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, debounceTime, map } from 'rxjs/operators';
import { Action } from 'redux';
import { UpdatePageField, UpdatePageSectionField, UpdateArtistPage, RemoveProfileImage } from '../action-creators';
import { UPDATE_PAGE_FIELD, UPDATE_PAGE_SECTION_FIELD, REMOVE_PROFILE_IMAGE } from '../actions';
import AppState from '../../state';


export const autosaveArtistPageEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, RemoveProfileImage | UpdatePageField<any> | UpdatePageSectionField<any, any>>(
      REMOVE_PROFILE_IMAGE,
      UPDATE_PAGE_FIELD,
      UPDATE_PAGE_SECTION_FIELD
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!(state.artist.active?.id)),
    debounceTime(2000),
    map((_) => new UpdateArtistPage())
  );